
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  LanguageCode,
  ProjectConditionContentResponse,
} from '../models';
import {
    LanguageCodeFromJSON,
    LanguageCodeToJSON,
    ProjectConditionContentResponseFromJSON,
    ProjectConditionContentResponseToJSON,
} from '../models';

export interface GetProjectConditionRequest {
    projectConditionId: string;
    language: LanguageCode;
}

/**
 * 
 */
export class ProjectConditionsApi extends runtime.BaseAPI {

    /**
     * Retrieves the HTML content of a project condition by its ID in the specified language. This endpoint is used for displaying project conditions in PDF format. If language is not specified or content is not available in the requested language, it falls back to English. 
     * Get project condition content by ID with optional language
          */
    async getProjectConditionRaw(requestParameters: GetProjectConditionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectConditionContentResponse>> {
        if (requestParameters['projectConditionId'] == null) {
            throw new runtime.RequiredError(
                'projectConditionId',
                'Required parameter "projectConditionId" was null or undefined when calling getProjectCondition().'
            );
        }

        if (requestParameters['language'] == null) {
            throw new runtime.RequiredError(
                'language',
                'Required parameter "language" was null or undefined when calling getProjectCondition().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['language'] != null) {
            queryParameters['language'] = requestParameters['language'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectConditionContentResponse>({
            path: `/compliance/api/project-conditions/{projectConditionId}`.replace(`{${"projectConditionId"}}`, encodeURIComponent(String(requestParameters['projectConditionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectConditionContentResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieves the HTML content of a project condition by its ID in the specified language. This endpoint is used for displaying project conditions in PDF format. If language is not specified or content is not available in the requested language, it falls back to English. 
     * Get project condition content by ID with optional language
          */
    async getProjectCondition(requestParameters: GetProjectConditionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectConditionContentResponse> {
        const response = await this.getProjectConditionRaw(requestParameters, initOverrides);
        return response._data;
    }

}
